import VizWrapper from "@components/common/Base/VizWrapper";
import ImageRenderer from "@components/common/Image";
import Link from "@components/common/Link";
import Title from "@components/common/Title";
import { SingleFeatureWithImageDynamicModel } from "@models/strapi-components/single-feature-with-image";
import React, { useRef } from "react";
import { twMerge } from "tailwind-merge";
export interface SingleFeatureWithImagePropsModel {
  componentData: SingleFeatureWithImageDynamicModel;
}
const SingleFeatureWithImage: React.FC<SingleFeatureWithImagePropsModel> = ({
  componentData,
}) => {
  const {
    id,
    title,
    subTitle,
    textColor = "#00000",
    bgColor = "#ffffff",
    textBlockImage: image,
    learnMoreLink,
    imgRight = true,
    divColor = "#FFFFFF",
  } = componentData;
  const ref = useRef<HTMLDivElement | null>(null);

  const dynamicClass = imgRight ? "xl:flex-row" : "xl:flex-row-reverse";
  const textDynamicClass = imgRight ? "xl:rounded-l-lg " : "xl:rounded-r-lg ";

  return (
    <VizWrapper
      className={twMerge(
        "flex flex-col justify-center items-center",
        dynamicClass
      )}
      ref={ref}
      id={id}
      style={{
        backgroundColor: divColor,
      }}
    >
      <div
        className={twMerge(
          "hidden xl:block max-w-[700px] xl:px-24 xl:py-16 z-10",
          textDynamicClass
        )}
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        <Title variant="h2" titleText={title} className="text-white" />
        <Title
          variant="paragraph"
          titleText={subTitle}
          className="text-white"
        />
        {learnMoreLink?.length && (
          <Link
            href={learnMoreLink}
            linkText="Learn More"
            className="text-white"
          />
        )}
      </div>
      <div
        className={twMerge(
          "xl:hidden pb-6 md:pb-8 xl:pb-[54px]",
          textDynamicClass
        )}
        style={{ backgroundColor: "#f0f3f6" }}
      >
        <Title
          variant="h2"
          titleText={title}
          className="text-center xl:text-left sm:max-w-[50%] xl:max-w-none mx-auto"
        />
        <Title
          variant="paragraph"
          titleText={subTitle}
          className="text-center xl:text-left sm:max-w-[60%] mx-auto xl:max-w-none"
        />

        {learnMoreLink?.length && (
          <Link
            href={learnMoreLink}
            linkText="Learn More"
            wrapperClassName="mx-auto text-center"
          />
        )}
      </div>
      <div className="px-8 xl:px-6 xl:py-[38px] xl:bg-white lg:rounded-3xl xl:shadow">
        <ImageRenderer
          image={image}
          className="z-0 rounded-lg overflow-hidden"
        />
      </div>
    </VizWrapper>
  );
};

export default SingleFeatureWithImage;
